import React, { Component, ReactDOM } from "react";
import injectSheet from "react-jss";
import Color from "color";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as Actions from "../../../Actions/Actions";
import { palette } from "../../../Theme/Theme";
// import ReactGA from 'react-ga'
import Responsive from "react-responsive";
import { isMobile } from "react-device-detect";
import Playlists from './Playlists'
import styled from 'styled-components'


const ThumbNail = styled.img

class Thumbnail extends Component {
  constructor(props) {
    super(props);
    this.showHero = this.showHero.bind(this);
    this.chooseShow = this.chooseShow.bind(this);
    this.state = {
      thumbNailClass: this.props.classes.thumbnail,
      infoContainer: this.props.classes.infoContainer,
      plusContainer: this.props.classes.plusContainer,
      playContainer: this.props.classes.playContainer,
      thumbNails: this.props.thumbNails,
      hasScrolled: false,
      ref: null,
      scrollAmount: 0,
      scrollConstant: 18.2,
      originalConstant: 18.2,
      Opacity: 1,
      width: 0,
      addToPlaylist: false
    };
  }

  render() {
    const { classes, content } = this.props;
    const { id } = content
    const { Body } = classes;
    let thumbNails;
    let buttonClass;
    return (
      <div style={{ zIndex: "0" }}>
        <div
          className={classes.img}
          onMouseOver={() => {
            this.setState({
              playContainer: this.props.classes.playContainerHovered,
              infoContainer: this.props.classes.infoContainerHovered,
              plusContainer: this.props.classes.plusContainerHovered
            });
          }}
          onMouseLeave={() => {
            this.setState({
              playContainer: this.props.classes.playContainer,
              infoContainer: this.props.classes.infoContainer,
              plusContainer: this.props.classes.plusContainer
            });
          }}
        >
          <img
            onClick={() => {
              this.showHero(this.props.content);
            }}
            onMouseLeave={this.props.mouseLeave}
            onMouseOver={this.props.hover}
            className={this.state.thumbNailClass}
            src={this.props.thumbnailImageUrl}
            alt=""
          />
          {this.props.thumbnailImageUrl !== "" ? (
            <div
              className={this.state.playContainer}
              onClick={this.chooseShow}
              onMouseLeave={() => {
                this.changeInfoState("leaving");
              }}
              onMouseOver={() => {
                this.changeInfoState("hovered");
              }}
            >
              <img
                src={require("../../../../assets/play.png")}
                alt=""
                className={classes.play}
              />
            </div>
          ) : null}
          {this.props.thumbnailImageUrl !== "" ? (
            <div
              onClick={()=>{this.props.dispatch({type: 'TOGGLE_ADD_TO_PLAYLIST', id})}}
              className={this.state.plusContainer}
              onMouseLeave={() => {
                this.changeInfoState("leaving");
              }}
              onMouseOver={() => {
                this.changeInfoState("hovered");
              }}
            >
              <i
                style={{ fontSize: "1vw" }}
                className={`${classes.info} fas fa-plus`}
              />
            </div>
          ) : null}
          {this.props.thumbnailImageUrl !== "" ? (
            <div
              onClick={() => {
                this.showHero(this.props.content);
              }}
              className={this.state.infoContainer}
              onMouseLeave={() => {
                this.changeInfoState("leaving");
              }}
              onMouseOver={() => {
                this.changeInfoState("hovered");
              }}
            >
              <i
                style={{ fontSize: "1vw" }}
                className={`${classes.info} fas fa-info`}
              />
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  changeInfoState(status) {
    if (status === "leaving") {
      this.props.hover();
      this.setState({ thumbNailClass: this.props.classes.thumbnail });
      return;
    }
    this.props.hover();
    this.setState({ thumbNailClass: this.props.classes.thumbnailHovered });
  }

  chooseShow = () => {    
    if(isMobile) {
      this.showHero(this.props.content)
      return;
    }
    if (!this.props.loggedUserState.logged) {
      this.showHero(this.props.content);
      return;
    }
    if (this.props.user.quality === "None") {
      this.showHero(this.props.content);
      return;
    }
    if (isMobile) {
      this.showHero(this.props.content)
      // console.log(this.props.content)
      // this.props.content.progress = 0;
      // this.props.dispatch(Actions.ChooseShow(this.props.content, this.props.rowNum, this.props.history));
      // this.props.history.push("/Home/Mobile");
      return;
    }
    this.props.content.progress = 0;
    this.props.dispatch(Actions.ChooseShow(this.props.content, this.props.rowNum, this.props.history));    
  }

  showHero(content) {
    content.rowNum = this.props.rowNum
    this.props.dispatch(Actions.ChooseHero(content));
  }

  showArrow() {
    this.setState({ Opacity: 1 });
  }

  hideArrow() {
    this.setState({ Opacity: 0 });
  }
}

const styles = {
  info: {
    color: "white"
  },
  infoContainerHovered: {
    transitionDelay: "300ms",
    transition: "all .4s",
    position: "absolute",
    zIndex: "2",
    left: "1vw",
    bottom: "1vw",
    borderRadius: "100%",
    width: "2vw",
    height: "2vw",
    border: "2px solid white",
    display: "flex",
    justifyContent: "center",
    backgroundColor: `${Color('black').alpha(.5)}`,
    alignItems: "center",
    opacity: "0.4",
    "&:hover": {
      cursor: "pointer",
      opacity: "0.99"
    }
  },

  infoContainer: {
    position: "absolute",
    borderRadius: "100%",
    left: "1vw",
    bottom: "1vw",
    transitionDelay: "300ms",
    transition: "all .4s",
    zIndex: "2",
    width: "2vw",
    height: "2vw",
    border: "2px solid white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    opacity: "0.0",
    "&:hover": {
      cursor: "pointer",
      opacity: "0"
    }
  },
  plusContainerHovered: {
    extend: 'infoContainerHovered',
    bottom: '4vw'
  },

  plusContainer: {
    extend: 'infoContainer',
  },

  play: {
    width: "3vw"
  },
  playContainerHovered: {
    position: "absolute",
    transitionDelay: "500ms",
    transition: "all .4s",
    zIndex: "2",
    borderRadius: "100%",
    width: "3vw",
    height: "3vw",
    border: "2px solid white",
    backgroundColor: `${Color('black').alpha(.5)}`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    opacity: "0.4",
    "&:hover": {
      cursor: "pointer",
      opacity: "0.99"
    }
  },
  playContainer: {
    transitionDelay: "500ms",
    transition: "all .4s",
    position: "absolute",
    zIndex: "2",
    borderRadius: "100%",
    width: "3vw",
    height: "3vw",
    border: "2px solid white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    opacity: "0.0",
    "&:hover": {
      cursor: "pointer",
      opacity: "0"
    }
  },
  img: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    overflow: "hidden"
  },
  block: {
    transition: "margin .4s",
    margin: "0"
  },
  Body: {
    // height: '27vh',
    // maxWidth: ' 80vw',
    minWidth: "100vw",
    overflowX: "scroll",
    overflowY: "hidden",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center"
  },
  thumbnail:{
    transition: "all .4s",
    transitionDelay: "200ms",
    transitionTimingFunction: "cubic-bezier(.77,.06,.47,.83)",
    width: props => props.isMobile ? '24vw' : "18vw",
    minWidth: "18vw",
    boxShadow: `2px 2px 10px rgb(0,0,0)`,
    verticalAlign: "bottom",
    margin: props => props.isMobile ? '.4vw' : '1vw',
    marginRight: props => props.isMobile ? '.4vw' : '.1vw',
    marginLeft: props => props.isMobile ? '.4vw' : '.1vw',    
    zIndex: "2",
    "&:hover": {
      cursor: "pointer",
      zIndex: "2",
      transform: props => props.isMobile ? 'scale(1,1)' : "scale(1.2,1.2)",
      marginLeft: props => props.isMobile ? '.4vw' : "2vw",
      marginRight: props => props.isMobile ? '.4vw' : "2vw",
    }
  },
  thumbnailHovered: {
    transition: "all .4s",
    transitionDelay: "300ms",
    transitionTimingFunction: "cubic-bezier(.77,.06,.47,.83)",
    width: "18vw",
    minWidth: "18vw",
    boxShadow: `2px 2px 10px rgb(0,0,0)`,
    verticalAlign: "bottom",
    marginRight: ".1vw",
    marginLeft: ".1vw",
    margin: "1vw",
    zIndex: "2",
    cursor: "pointer",
    zIndex: "2",
    transform: props => props.isMobile ? "scale(1,1)" : "scale(1.2,1.2)",
    marginLeft: props => props.isMobile ? '.4vw' : "2vw",
    marginRight: props => props.isMobile ? '.4vw' : "2vw",
  },
  scrollButtonRight: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "2rem",
    transition: "all .4s",
    backgroundColor: Color(palette.white)
      .alpha(0.4)
      .toString(),
    color: Color(palette.black)
      .alpha(1)
      .darken(0.2)
      .toString(),
    // borderRadius: '5px 0px 0px 5px', 195.359px
    width: "4.4vw",
    height: "10.175vw",
    right: "0",
    position: "absolute",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: Color(palette.white)
        .alpha(0.9)
        .toString(),
      color: Color(palette.black)
        .darken(0.7)
        .alpha(1)
        .toString()
    }
  },
  scrollButtonLeft: {
    extend: "scrollButtonRight",
    // borderRadius: '0px 5px 5px 0px',
    left: "0"
  },
  arrowLeft: {
    paddingRight: ".5vw"
  },
  arrowRight: {
    paddingLeft: ".5vw"
  }
};

const mapStateToProps = state => {
  return {
    user: state.mainState.user,
    loggedUserState: state.mainState.loggedUserState,
    libraryState: state.mainState.libraryState,
    library: state.mainState.library
  };
};

export default withRouter(
  connect(mapStateToProps)(injectSheet(styles)(Thumbnail))
);



// WEBPACK FOOTER //
// ./src/js/Components/Home/Shows/thumbNail.jsx